export default [
  {
    path: '/homecharging/lokasi_homecharging',
    name: 'homecharging-lokasi_homecharging',
    component: () => import('../../views/homecharging/lokasi_homecharging.vue'),
    meta: {
      title: 'Home Charging',
      activeMenu: 'Home Charging',
      breadcrumb: [
        {
          text: 'Home Charging',
          disabled: true
        },
        {
          text: 'Lokasi Home Charging',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/homecharging/dashboard-homecharging',
    name: 'dashboard-homecharging',
    component: () => import('../../views/homecharging/DashboardHomecharging.vue'),
    meta: {
      title: 'Home Charging',
      activeMenu: 'Home Charging',
      breadcrumb: [
        {
          text: 'Home Charging',
          disabled: true
        },
        {
          text: 'Dashboard Home Charging',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/homecharging/pelanggan-homecharging',
    name: 'pelanggan-homecharging',
    component: () => import('../../views/homecharging/pelangganHomeCharging.vue'),
    meta: {
      title: 'Home Charging',
      activeMenu: 'Home Charging',
      breadcrumb: [
        {
          text: 'Home Charging',
          disabled: true
        },
        {
          text: 'Pelanggan Home Charging',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/homecharging/dpld-homecharging',
    name: 'dpld-homecharging',
    component: () => import('../../views/homecharging/DPLDhomeCharging.vue'),
    meta: {
      title: 'Home Charging',
      activeMenu: 'Home Charging',
      breadcrumb: [
        {
          text: 'Home Charging',
          disabled: true
        },
        {
          text: 'DLPD Home Charging',
          disabled: true
        }
      ]
    }
  }
]
